import { useLanguage } from '../context/LanguageContext';
import { MapPin } from 'lucide-react';

// Profile image URL
const PROFILE_IMAGE = "https://customer-assets.emergentagent.com/job_satya-self/artifacts/e3fdxtp9_DSC02265.jpeg";

const AboutSection = () => {
  const { t, language } = useLanguage();

  return (
    <section 
      id="about"
      className="py-20 md:py-28"
      style={{ backgroundColor: 'var(--warm-white)' }}
      data-testid="about-section"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Image - 30% smaller */}
          <div className={`relative ${language === 'he' ? 'md:order-2' : ''}`}>
            <div 
              className="relative rounded-3xl overflow-hidden shadow-2xl photo-3d-container"
              style={{ maxWidth: '265px', margin: '0 auto', perspective: '800px' }}
            >
              <img 
                src={PROFILE_IMAGE}
                alt="Eran MH - Life Coach"
                className="w-full h-auto object-cover animate-3d-depth"
                data-testid="about-profile-image"
              />
              {/* Subtle color overlay */}
              <div 
                className="absolute inset-0"
                style={{ 
                  background: 'linear-gradient(135deg, rgba(90, 125, 90, 0.1) 0%, transparent 50%)'
                }}
              />
            </div>
            {/* Decorative elements */}
            <div 
              className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full -z-10"
              style={{ backgroundColor: 'var(--sand-200)' }}
            />
            <div 
              className="absolute -top-6 -left-6 w-24 h-24 rounded-full -z-10"
              style={{ backgroundColor: 'var(--sage-100)' }}
            />
          </div>

          {/* Content */}
          <div className={language === 'he' ? 'md:order-1' : ''}>
            <h2 
              className="text-3xl md:text-4xl mb-6"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
            >
              {t('about_title')}
            </h2>

            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>{t('about_p1')}</p>
              <p>{t('about_p2')}</p>
              <p>{t('about_p3')}</p>
              <p>{t('about_p4')}</p>
              <p className="font-medium" style={{ color: 'var(--charcoal)' }}>
                {t('about_p5')}
              </p>
            </div>

            {/* Location */}
            <div 
              className="inline-flex items-center gap-2 mt-8 p-4 rounded-xl"
              style={{ backgroundColor: 'var(--sand-50)' }}
            >
              <MapPin size={20} style={{ color: 'var(--sage-600)' }} />
              <span className="text-gray-700">{t('about_location')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
